import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type LegalDoc = 'terminos' | 'privacidad';
const legalContent: Record<LegalDoc, {
  title: string;
  body: string[];
}> = {
  terminos: {
    title: 'Términos y Condiciones',
    body: ['Al adquirir "El Código Secreto del Asado Chileno" aceptas estos Términos y Condiciones. El producto es de carácter digital y se entrega de forma inmediata a través de un enlace de descarga enviado a tu correo electrónico.', 'El acceso al material es para uso personal e intransferible. Queda prohibida la reproducción, distribución o reventa total o parcial del contenido sin autorización expresa.', 'El pago se realiza una sola vez y otorga acceso de por vida al material adquirido, incluyendo las actualizaciones disponibles al momento de la compra.', 'Los precios están expresados en pesos chilenos (CLP). El valor mostrado es el valor final a pagar.']
  },
  privacidad: {
    title: 'Políticas de Privacidad',
    body: ['Respetamos y protegemos tu privacidad. Los datos que nos entregas (nombre y correo electrónico) se utilizan exclusivamente para procesar tu compra y enviarte el acceso al producto digital.', 'No compartimos, vendemos ni cedemos tu información personal a terceros sin tu consentimiento, salvo cuando sea requerido por ley.', 'Podemos enviarte comunicaciones relacionadas con tu compra y, ocasionalmente, ofertas relevantes. Puedes solicitar la baja de estas comunicaciones en cualquier momento.', 'Tus datos se almacenan de forma segura y encriptada. Para solicitar la eliminación de tus datos puedes contactarnos por correo electrónico.']
  }
};
export function Footer() {
  const [activeDoc, setActiveDoc] = useState<LegalDoc | null>(null);
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setActiveDoc(null);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);
  const doc = activeDoc ? legalContent[activeDoc] : null;
  return <footer className="bg-bbq-dark py-12 px-4 border-t border-white/5 text-center" data-id="element-44">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-45">
        <img src="https://cdn.magicpatterns.com/uploads/5N168WCMoDKJb6bRLWfvc8/logo_asado.png" alt="Logo Asado" className="h-12 object-contain opacity-50 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500 mb-8" data-id="element-46" />
        <p className="text-gray-600 text-sm mb-4" data-id="element-47">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <div className="flex gap-4 text-gray-500 text-sm" data-id="element-48">
          <button type="button" onClick={() => setActiveDoc('terminos')} className="hover:text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-bbq-ember rounded" data-id="element-49">
            Términos y Condiciones
          </button>
          <span aria-hidden="true" data-id="element-50">|</span>
          <button type="button" onClick={() => setActiveDoc('privacidad')} className="hover:text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-bbq-ember rounded" data-id="element-51">
            Políticas de Privacidad
          </button>
        </div>
        <p className="text-gray-600 text-xs mt-8" data-id="element-52">
          © {new Date().getFullYear()} El Código del Asado Chileno. Todos los
          derechos reservados.
        </p>
      </div>

      <AnimatePresence data-id="element-53">
        {doc && <motion.div className="fixed inset-0 z-[100] flex items-center justify-center p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-54">
            <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setActiveDoc(null)} data-id="element-55" />
            <motion.div className="relative z-10 w-full max-w-lg bg-bbq-surface border border-white/10 rounded-2xl shadow-2xl text-left max-h-[80vh] flex flex-col" initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} data-id="element-56">
              <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-57">
                <h3 id="legal-modal-title" className="text-xl font-display font-bold text-white uppercase tracking-wide" data-id="element-58">
                  {doc.title}
                </h3>
                <button type="button" onClick={() => setActiveDoc(null)} aria-label="Cerrar" className="text-gray-400 hover:text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-bbq-ember rounded p-1" data-id="element-59">
                  <X size={22} data-id="element-60" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto space-y-4 text-gray-400 text-sm leading-relaxed" data-id="element-61">
                {doc.body.map((p, i) => <p key={i} data-id="element-62">{p}</p>)}
              </div>
              <div className="p-6 border-t border-white/10 text-right" data-id="element-63">
                <button type="button" onClick={() => setActiveDoc(null)} className="bg-bbq-ember hover:bg-bbq-ember-dark text-white font-display uppercase tracking-wider text-sm py-2 px-6 rounded-md transition-colors" data-id="element-64">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </footer>;
}